import { useEffect } from "react";
import { useLocation } from "react-router";
import { Container } from "reactstrap";
import styled from "styled-components";

import NewFooter from "../Footers/NewFooter";
import NewNavbar from "../Navbar/NewNavbar";

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const ContentSection = styled.section`
  flex: 1;
  padding: 120px 0 60px;
  background: #ffffff;
`;

const PageTitle = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
`;

const ContentWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: justify;
  line-height: 1.8;
  color: #374151;

  h2 {
    font-size: 24px;
    font-weight: 600;
    color: #1a1a1a;
    margin-top: 32px;
    margin-bottom: 16px;
  }

  p {
    margin-bottom: 16px;
  }
`;

/**
 * Shared shell for static legal pages (Privacy Policy, Terms & Conditions).
 * Scrolls to a `#section` anchor on load when present (e.g. links into Terms).
 * @param {{ title: string, content: React.ReactNode }} props
 */
const LegalPage = ({ title, content }) => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.split("#")[1]);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [hash]);

  return (
    <PageContainer>
      <NewNavbar />
      <ContentSection>
        <Container>
          <PageTitle>{title}</PageTitle>
          <ContentWrapper>{content}</ContentWrapper>
        </Container>
      </ContentSection>
      <NewFooter />
    </PageContainer>
  );
};

export default LegalPage;
